import { SagaIterator } from "redux-saga";
import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { createCrilicReportApi } from "./api";
import {  CreateCrilicReportSaga, CrilicReportReduxTypes } from "./types";

function* createCrilicReport({ payload }: CreateCrilicReportSaga): SagaIterator {
    try {
        const response = yield call(createCrilicReportApi, payload);
        yield put({
            type: CrilicReportReduxTypes.CRILIC_REPORT_SUCCESS,
            payload: { data: response.data.data }
        })
    } catch (error: any) {
        yield put({
            type: CrilicReportReduxTypes.CRILIC_REPORT_ERROR,
            payload:{ error: error }
    })
}
}

export function* watchCreateCrilicReport(){
yield takeEvery(CrilicReportReduxTypes.CRILIC_REPORT,createCrilicReport)
}

function* crilicReportSaga(){
    yield all([fork(watchCreateCrilicReport)])
}

export default crilicReportSaga;
